import React from 'react';
import { Security, VerifiedUser, Lock } from '@mui/icons-material';

const SecurityHero = () => {
    return (
        <section className="bg-gradient-to-br from-gray-900 to-amber-900 text-white py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <div className="flex justify-center mb-6">
                        <div className="p-4 bg-amber-500/20 rounded-2xl">
                            <Security className="text-6xl text-amber-400" />
                        </div>
                    </div>

                    <h1 className="text-5xl lg:text-6xl font-bold mb-6">
                        Sécurité & Conformité
                    </h1>

                    <p className="text-xl text-amber-100 max-w-3xl mx-auto leading-relaxed">
                        Chez Netikash, la sécurité de vos transactions est notre priorité absolue.
                        Nous maintenons les plus hauts standards de sécurité et de conformité
                        pour protéger vos données et celles de vos clients.
                    </p>

                    <div className="grid md:grid-cols-3 gap-8 mt-12 max-w-4xl mx-auto">
                        <div className="text-center">
                            <div className="bg-amber-500/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <VerifiedUser className="text-3xl text-amber-300" />
                            </div>
                            <h3 className="text-lg font-semibold mb-2">Certifié PCI DSS Niveau 1</h3>
                            <p className="text-amber-100 text-sm">Plus haut niveau de certification pour la sécurité des paiements</p>
                        </div>

                        <div className="text-center">
                            <div className="bg-amber-500/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Lock className="text-3xl text-amber-300" />
                            </div>
                            <h3 className="text-lg font-semibold mb-2">Chiffrement de Bout en Bout</h3>
                            <p className="text-amber-100 text-sm">Toutes les données sensibles sont chiffrées HmacSHA256</p>
                        </div>

                        <div className="text-center">
                            <div className="bg-amber-500/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Security className="text-3xl text-amber-300" />
                            </div>
                            <h3 className="text-lg font-semibold mb-2">Surveillance 24/7</h3>
                            <p className="text-amber-100 text-sm">Monitoring continu et détection des menaces</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SecurityHero;